import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware } from 'redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { RootApp } from './utility/rootapp';

import 'babel-polyfill';

import 'normalize-css/normalize.css';

import reducers from './reducers';

import Home from './home/Home';
import Admin from './admin/Admin';
// import registerServiceWorker from './registerServiceWorker';

import './index.css';

const history = createHistory();

export const store = createStore(
  reducers,
  applyMiddleware(
    thunkMiddleware,
    routerMiddleware(history),
    createLogger()
  )
);

const App = RootApp(() => {
  return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/admin" component={Admin} />
          <Route path="/:type/:id?" component={Home} />
          <Redirect from="/" to="/order" />
        </Switch>
      </ConnectedRouter>
    );
  });
  ReactDOM.render(<Provider store={store}><App/>
    </Provider>, document.getElementById('root')
  );

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js